module.exports = __webpack_public_path__ + "8a5356e9/img/pdf-icon.79f04a36.svg";